import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { isDealerOpen } from './dealer-details-work-hours-helper';

export function DealerWorkTimeStatus({ className, dealerLocation, workHours, currentDay }) {
  const isOpenNow = isDealerOpen(dealerLocation, workHours, currentDay);
  return (
    <div
      className={classNames('dealer-work-time-status fw-bold', className)}
      style={{ marginRight: '16px !important', fontSize: '0.75rem' }}
    >
      {isOpenNow ? <span className="text-success">Open Now</span> : <span className="text-danger">Closed Now</span>}
    </div>
  );
}

DealerWorkTimeStatus.propTypes = {
  dealerLocation: PropTypes.shape({
    gmtOffset: PropTypes.number,
    dst: PropTypes.string,
  }).isRequired,
  workHours: DealerInfoEntities.WorkHours.isRequired,
  currentDay: PropTypes.string,
  className: PropTypes.string,
};

DealerWorkTimeStatus.defaultProps = {
  currentDay: '',
  className: '',
};
